import { createContext, useContext, useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

const BookServiceContext = createContext();

export function useBookServiceContext() {
  return useContext(BookServiceContext);
}

export function BookServiceProvider(props) {
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState();
  const [currentSubStep, setCurrentSubStep] = useState(0);
  const [selectedPolicy, setSelectedPolicy] = useState();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedDate, setSelectedDate] = useState();
  const [selectedTime, setSelectedTime] = useState();
  const [currentStep, setCurrentStep] = useState(1);
  const [showAlert, setShowAlert] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    clearStates();
  }, [navigate]);

  const handleBookHomeService = () => {
    navigate("/book-service/home");
  };

  const handleSetNextStep = (step) => {
    if (step == 1) {
      setCurrentSubStep(0);
    }

    setCurrentStep(step);
  };

  const handleStepBack = () => {
    navigate(-1);
  };

  const clearStates = () => {
    setSelectedPolicy();
    setSelectedOrders([]);
    setSelectedFiles([]);
    setSelectedAddress();
    setSelectedDate();
    setSelectedTime();
    setCurrentStep(1);
    setCurrentSubStep(0);
    setShowAlert(false);
  };

  const handleCancelBooking = () => {
    clearStates();
    navigate("/book-service");
  };

  const handleCancel = () => {
    navigate("/home", { replace: true });
  };

  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  const handleSelectProcedure = () => {};

  const handleBackToDashboard = () => {
    navigate("/home");
  };

  const data = {
    handleBookHomeService,
    handleSelectProcedure,
    handleBackToDashboard,
    handleCancelBooking,
    setSelectedAddress,
    handleSetNextStep,
    setCurrentSubStep,
    setSelectedPolicy,
    handleCloseAlert,
    setSelectedFiles,
    setSelectedTime,
    setSelectedDate,
    handleStepBack,
    handleCancel,
    setShowAlert,
    navigate,

    selectedAddress,
    selectedOrders,
    currentSubStep,
    selectedPolicy,
    selectedFiles,
    selectedTime,
    selectedDate,
    currentStep,
    showAlert,
  };

  const memoData = useMemo(
    () => data,
    [
      selectedAddress,
      currentSubStep,
      selectedPolicy,
      selectedOrders,
      selectedFiles,
      selectedTime,
      selectedDate,
      currentStep,
      showAlert,
    ]
  );

  return (
    <BookServiceContext.Provider value={memoData}>
      {props.children}
    </BookServiceContext.Provider>
  );
}

// PropTypes validation
BookServiceProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
